import { render, staticRenderFns } from "./CommonUpload.vue?vue&type=template&id=f47c5b7c&scoped=true&"
import script from "./CommonUpload.vue?vue&type=script&lang=ts&"
export * from "./CommonUpload.vue?vue&type=script&lang=ts&"
import style0 from "./CommonUpload.vue?vue&type=style&index=0&id=f47c5b7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47c5b7c",
  null
  
)

export default component.exports